// Self-contained data for the Belciña Jewelry Incorporated concept website.
export const BIZ = {
  name: "Belciña Jewelry Incorporated",
  brand: "BELCIÑA JEWELRY",
  sub: "Belciña Jewelry, Inc. — Dumaguete City",
  tagline: '"Service with Honesty is our Guarantee"',
  intro:
    "We're Belciña Jewelry, Inc., housed in our recognizable art-deco corner building in downtown Dumaguete, with years of local trade in jewelry, watches and gold behind us.",
  address: "Pacito Belciña Bldg., Maria Cristina cor. San Juan St., Dumaguete City, Negros Oriental",
  phone: "+63 35 422 6119",
  rating: "4.2",
  reviewCount: 35,
  facebookMain: "https://www.facebook.com/bji21021/",
  facebookAlt: "https://www.facebook.com/belcinajewelry/",
  mapEmbed: "https://www.google.com/maps?q=Maria+Cristina+San+Juan+St+Dumaguete+City&output=embed",
};

export const HIGHLIGHTS = [
  { title: "Downtown Landmark", text: "Our recognizable art-deco corner building near the city center." },
  { title: "Watches & Jewelry", text: "We carry watches alongside our main jewelry line." },
  { title: "Community Presence", text: "We support local events, including pageants like Miss Silliman." },
  { title: "Decades of Trade", text: "An established Dumaguete jeweler, trusted by generations of locals." },
];

export const PRODUCTS = [
  { name: "Van Cleef–style Clover Necklace", desc: "Multi-color clover motif necklace on a fine gold chain.", img: "/belcina/prod-clover-necklace.jpg" },
  { name: "Clover Bracelet Collection", desc: "Three styles of clover-charm bracelets in polished gold.", img: "/belcina/prod-clover-bracelets.jpg" },
  { name: "Custom-Engraved Wedding Bands", desc: "Matching gold bands, each engraved with the couple's names.", img: "/belcina/prod-engraved-rings.jpg" },
];

export const STEPS = [
  { n: "1", title: "Visit", text: "Drop by the Maria Cristina corner San Juan St. store in downtown Dumaguete." },
  { n: "2", title: "Ask", text: "Ask staff about a piece's purity, price, and whether engraving is available." },
  { n: "3", title: "Confirm", text: "Confirm final price and any customization (like name engraving) in person." },
  { n: "4", title: "Buy", text: "Complete your purchase in-store, backed by decades of local trade." },
];
